import { useFormik } from "formik";
import { z } from "zod";
import {
  AdminInviteControllerInviteResponse,
  adminPostAdminInviteReqDtoSchema,
  useAdminInviteControllerInvite,
} from "service";
import { AdminPostAdminInviteReqDto } from "service/api/estabrookSchemas";
import { queryKeyFn } from "service/api/estabrookContext";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { toast } from "react-toastify";
import { queryClient } from "@/query-client";

const initialValues: AdminPostAdminInviteReqDto = {
  firstName: "",
  lastName: "",
  email: "",
  role: "admin",
};

// firstName/lastName are unconstrained strings in the generated schema, but
// the invite form must not submit blank names.
const validationSchema = adminPostAdminInviteReqDtoSchema.extend({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
});

const useAddMemberForm = (organizationId: string, onFormSuccess: () => void) => {
  const { mutate, isLoading } = useAdminInviteControllerInvite({
    onSuccess: (data: AdminInviteControllerInviteResponse) => {
      toast.success(`Invite sent to ${data.data?.email}`);
      queryClient.invalidateQueries(
        queryKeyFn({
          path: "/api/v1/admin/accounts",
          operationId: "adminAccountControllerGetAll",
          variables: {},
        }),
      );
      memberForm.resetForm();
      onFormSuccess();
    },
  });

  const memberForm = useFormik<AdminPostAdminInviteReqDto>({
    initialValues,
    validationSchema: toFormikValidationSchema(validationSchema),
    onSubmit: (values) => {
      mutate({ body: values, queryParams: { organizationId } });
    },
  });

  return { memberForm, isLoading };
};

export default useAddMemberForm;
